import { render, staticRenderFns } from "./ResultadoFinalComponent.vue?vue&type=template&id=32591978&"
import script from "./ResultadoFinalComponent.vue?vue&type=script&lang=ts&"
export * from "./ResultadoFinalComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResultadoFinalComponent.vue?vue&type=style&index=0&id=32591978&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports